import React from 'react';
import { CommandBar, ICommandBarItemProps, SelectionMode, Selection, DetailsListLayoutMode, DetailsList, IColumn, Pivot, PivotItem, ShimmeredDetailsList, ConstrainMode, SearchBox, IDetailsListProps, IDetailsRowStyles, DetailsRow, MarqueeSelection, MessageBar, MessageBarType } from '@fluentui/react';
import { IAssignmentDTO } from '../../models';
import AssignmentPanel from './AssignmentPanel/AssignmentPanel';
import { Services } from '../../services';
import App from '../../App';
import styles from './Dashboard.module.scss';
import Utilities, { Status } from '../../helpers/Utilities';
import { AssignmentServiceProvider, IAssignmentService } from '../../services/assignmentService';

interface IDashboardState {
  isAssignmentsLoading: boolean;
  assignments: IAssignmentDTO[];
  showAssignmentPanel: boolean;
  showAssignmentPanelRawTimber: boolean;
  selectedAssignment?: IAssignmentDTO;
  assignment_Columns: IColumn[];
  assignment_Columns_Approved: IColumn[];
  assignment_Columns_DL: IColumn[];
  // assignment_Columns_DL_Approved: IColumn[];
  assignment_Columns_Admin: IColumn[];
  createOnbehalfOfSupplier: boolean;
  currentPivot?: string;
  searchTerm?: string;
  selectedAssignments?: IAssignmentDTO[];
  isOffline: boolean;
}

interface IDashboardProps {

}

export default class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
  private assignmentService: IAssignmentService;
  private _allItems: IAssignmentDTO[] = [] as IAssignmentDTO[];

  //#region Constructor Props
  constructor(props: IDashboardProps) {
    super(props);

    this.assignmentService = Services.AssignmentService.Initialize(new AssignmentServiceProvider());

    //#region Column definitions
    const assignment_Columns: IColumn[] = [
      {
        key: 'created',
        name: 'Dato',
        fieldName: 'created',
        minWidth: 80,
        maxWidth: 80,
        isResizable: true,
        onRender: (item: IAssignmentDTO) => {
          if (item.approvedDate) {
            return item.approvedDate.toLocaleDateString();
          }

          return item.created?.toLocaleDateString();
        },
        onColumnClick: this._onColumnClick.bind(this),
      },
      {
        key: 'orderName',
        name: 'Opgavenavn',
        fieldName: 'orderName',
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick.bind(this),
      },
      {
        key: 'status',
        name: 'Status',
        fieldName: 'status',
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick.bind(this),
        onRender: (item: IAssignmentDTO) => {
          switch (item.status) {
            case Status.Rejected:
              return <span className={styles.rejected}>{item.status}</span>;
            case Status.RequiresAdditionalInfo:
              return <span className={styles.requiresAdditionalInfo}>{item.status}</span>;
          }
          return <span>{item.status}</span>
        }
      },
      {
        key: 'estimatedAmount',
        name: 'Mængde',
        fieldName: 'estimatedAmount',
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
        onRender: (item: IAssignmentDTO) => {
          return item.estimatedAmount ? `${item.estimatedAmount} rm` : "";
        },
        onColumnClick: this._onColumnClick.bind(this),
      }
    ];

    const assignment_Columns_Approved = assignment_Columns.slice();
    assignment_Columns_Approved.splice(2, 0, {
      key: 'hdaoNo',
      name: 'Dalgas AO nr.',
      fieldName: 'hdaoNo',
      minWidth: 80,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: IAssignmentDTO) => {
        return item.hdaoNo?.toLocaleString();
      },
      onColumnClick: this._onColumnClick.bind(this),
    });

    const assignment_Columns_DL: IColumn[] = [
      {
        key: 'created',
        name: 'Dato',
        fieldName: 'created',
        minWidth: 80,
        maxWidth: 80,
        isResizable: true,
        onRender: (item: IAssignmentDTO) => {
          if (item.approvedDate) {
            return item.approvedDate.toLocaleDateString()
          }

          return item.created?.toLocaleDateString();
        },
        onColumnClick: this._onColumnClickDL.bind(this),
      },
      {
        key: 'supplierName',
        name: 'Leverandør',
        fieldName: 'supplierName',
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClickDL.bind(this),
      },
      {
        key: 'orderName',
        name: 'Opgavenavn',
        fieldName: 'orderName',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClickDL.bind(this),
      },
      {
        key: 'hdaoNo',
        name: 'Dalgas AO nr.',
        fieldName: 'hdaoNo',
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
        onRender: (item: IAssignmentDTO) => {
          return item.hdaoNo?.toLocaleString();
        },
        onColumnClick: this._onColumnClickDL.bind(this),
      },
      {
        key: 'status',
        name: 'Status',
        fieldName: 'status',
        minWidth: 100,
        maxWidth: undefined,
        isResizable: true,
        onColumnClick: this._onColumnClickDL.bind(this),
        onRender: (item: IAssignmentDTO) => {
          switch (item.status) {
            case Status.WaitingForApproval:
              return <span className={styles.waitingForApproval}>{item.status}</span>;
            case Status.Approved:
              return <span className={styles.approved}>{item.status}</span>;
            case Status.Rejected:
              return <span className={styles.rejected}>{item.status}</span>;
            case Status.RequiresAdditionalInfo:
              return <span className={styles.requiresAdditionalInfo}>{item.status}</span>;
            case Status.Offline:
              return <span className={styles.offline}>{item.status}</span>;
          }
          return <span>{item.status}</span>
        }
      },
      {
        key: 'estimatedAmount',
        name: 'Mængde',
        fieldName: 'estimatedAmount',
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
        onRender: (item: IAssignmentDTO) => {
          return item.estimatedAmount ? `${item.estimatedAmount} rm` : "";
        },
        onColumnClick: this._onColumnClickDL.bind(this),
      }
    ];

    const assignment_Columns_Admin = assignment_Columns_DL.slice();
    assignment_Columns_Admin.push({
      key: 'region',
      name: 'Region',
      fieldName: 'regionName',
      minWidth: 80,
      maxWidth: 200,
      isResizable: true,
      onColumnClick: this._onColumnClickDL.bind(this),
    });
    //#endregion Column definitions

    //#region State
    this.state = {
      assignments: [] as IAssignmentDTO[],
      isAssignmentsLoading: true,
      showAssignmentPanel: false,
      showAssignmentPanelRawTimber: false,
      assignment_Columns: assignment_Columns,
      assignment_Columns_Approved: assignment_Columns_Approved,
      assignment_Columns_DL: assignment_Columns_DL,
      assignment_Columns_Admin: assignment_Columns_Admin,
      createOnbehalfOfSupplier: false,
      isOffline: !navigator.onLine,
    }
  }

  //#region Metoder
  private handleOnlineStatus = () => {
    this.setState({ isOffline: !navigator.onLine }, () => {
      this.getData(false);
    });
  };

  public componentDidMount() {
    window.addEventListener('online', this.handleOnlineStatus);
    window.addEventListener('offline', this.handleOnlineStatus);
    this.getData(false);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnlineStatus);
    window.removeEventListener('offline', this.handleOnlineStatus);
  }

  public render(): React.ReactElement<IDashboardProps> {
    if (App.IsUserInRole("DL") ) {
      return this.renderForDL();
    }

    if ( App.IsUserInRole("Purchaser")) {
      return this.renderForPurchaser();
    }

    if (App.IsUserInRole("Finance") || App.IsUserInRole("Admin")) {
      return this.renderForAdmin();
    }

    return this.renderForSupplier();
  }

  private _selection = new Selection({
    onSelectionChanged: () => {
      this.setState({
        selectedAssignments: this._selection.getSelection() as IAssignmentDTO[],
      });
    },
  });

  private async markAsComplete() {
    if (this.state.selectedAssignments) {
      const values = await Promise.all(
        this.state.selectedAssignments.map(async (assignment: IAssignmentDTO) => {
          await this.assignmentService.UpdateAssignment({ ...assignment, status: Status.Completed });
        })
      );

      // Force reload afterwards
      window.location.reload();
    }
  }

  private getOfflineAssignments(): IAssignmentDTO[] {
    const offlineAssignments: IAssignmentDTO[] = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("offlineAssignment_")) {
        const offlineData = localStorage.getItem(key);
        if (offlineData) {
          const parsedData: Partial<IAssignmentDTO> = JSON.parse(offlineData);
          // Extract offlineId from the key if not present in the object
          if (!parsedData.offlineId) {
            parsedData.offlineId = key.replace("offlineAssignment_", "");
          }
          if (parsedData.trappingDate) {
            parsedData.trappingDate = new Date(parsedData.trappingDate);
          }
          if (parsedData.created && typeof parsedData.created === 'string') {
            parsedData.created = new Date(parsedData.created);
          }
          offlineAssignments.push({ ...parsedData, status: Status.Offline } as IAssignmentDTO);
        }
      }
    }
    return offlineAssignments;
  }
  //#endregion Metoder

  //#region Render leverandør
  private renderForSupplier(): React.ReactElement<IDashboardProps> {
    const offlineCount = this._allItems.filter(d => d.status == Status.Offline).length;
    const CommandBar_Assignments: ICommandBarItemProps[] = [
      {
        key: 'newAssignment',
        text: 'Ny opgave',
        iconProps: { iconName: 'Add' },
        disabled: this.state.isAssignmentsLoading,
        onClick: () => { this.setState({ selectedAssignment: undefined, showAssignmentPanel: true }) }
      }
    ];

    const archivedAssignmentsCount = this._allItems.filter(d => d.status == Status.Completed).length;

    return (
      <div className={styles.dashboard}>
        <div className={styles.heading}><h3>Opgaveoverblik</h3></div>
        <CommandBar className={styles.assignmentsCommandBar} items={CommandBar_Assignments} styles={{ root: { paddingLeft: "0px" } }} farItems={this.CreateFarMenuItems()} />
        <Pivot selectedKey={this.state.currentPivot} onLinkClick={(item?: PivotItem, ev?: React.MouseEvent<HTMLElement>) => { this.preload(item); }}>
          <PivotItem itemKey={"Pivot_1"} headerText={`Mine opgaver (${this._allItems.filter(d => d.status !== Status.Approved).length})`}>
            <div >
              <ShimmeredDetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status !== Status.Approved)}
                columns={this.state.assignment_Columns}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                enableShimmer={this.state.isAssignmentsLoading}
                setKey="set"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_2"} headerText={`Opgaver godkendt af Dalgas (${this._allItems.filter(d => d.status == Status.Approved).length})`}>
            <div >
              <DetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status == Status.Approved)}
                columns={this.state.assignment_Columns_Approved}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setApproved"
              />
            </div>
          </PivotItem>
          {offlineCount > 0 && (
            <PivotItem itemKey={"Pivot_Offline"} headerText={`Offline opgaver (${offlineCount})`}>
              <div >
                <DetailsList
                  items={this.state.assignments.filter(d => d.status == Status.Offline)}
                  columns={this.state.assignment_Columns}
                  selectionMode={SelectionMode.none}
                  onRenderRow={this._onRenderRow?.bind(this)}
                  constrainMode={ConstrainMode.unconstrained}
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  setKey="setOffline"
                />
              </div>
            </PivotItem>
          )}
          <PivotItem itemKey={"Pivot_Archive"} headerText={`Afsluttede opgaver ${archivedAssignmentsCount > 0 ? `(${archivedAssignmentsCount})` : ""}`}>
            <div >
              <DetailsList
                items={this.state.assignments.filter(d => d.status == Status.Completed)}
                columns={this.state.assignment_Columns_Approved}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setApproved"
              />
            </div>
          </PivotItem>
        </Pivot>
        {this.state.showAssignmentPanel && <AssignmentPanel allowSelectionOfSupplier={false} selectedAssignment={this.state.selectedAssignment} onChanged={(assignment: IAssignmentDTO, showAssignmentPanel) => { this.setState({ selectedAssignment: assignment }); this.getData(showAssignmentPanel); }} onDismiss={() => { this.setState({ showAssignmentPanel: false }); this.getData(false); }} />}
      </div>
    );
  }
  //#endregion Render leverandør

  //#region Render Driftsleder
  private renderForDL(): React.ReactElement<IDashboardProps> {
    const offlineCount = this._allItems.filter(d => d.status == Status.Offline).length;
    const CommandBar_Assignments: ICommandBarItemProps[] = [
      {
        key: 'new',
        text: 'Ny opgave på vegne af leverandør',
        iconProps: { iconName: 'Add' },
        disabled: this.state.isAssignmentsLoading,
        onClick: () => { this.setState({ selectedAssignment: undefined, createOnbehalfOfSupplier: true, showAssignmentPanel: true }) }
      }
    ];

    if (this.state.currentPivot == "Pivot_DL_4" && this.state.selectedAssignments != undefined && this.state.selectedAssignments?.length > 0) {
      CommandBar_Assignments.push({
        key: 'complete',
        text: `Afslut ${this.state.selectedAssignments?.length} opgave${this.state.selectedAssignments?.length > 1 ? "r" : ""}`,
        iconProps: { iconName: 'CheckMark' },
        disabled: this.state.selectedAssignments == undefined || this.state.selectedAssignments?.length == 0,
        onClick: () => { if (window.confirm("Er du sikker på, at du ønsker at markere de valgte opgaver som afsluttet?")) this.markAsComplete(); }
      });
    }

    const archivedAssignmentsCount = this._allItems.filter(d => d.status == Status.Completed).length;

    return (
      <div className={styles.dashboard}>
        <div className={styles.heading}><h3>Aktuelle opgaver i min region</h3></div>
        <CommandBar className={styles.assignmentsCommandBar} items={CommandBar_Assignments} styles={{ root: { paddingLeft: "0px" } }} farItems={this.CreateFarMenuItems()} />
        <Pivot selectedKey={this.state.currentPivot} onLinkClick={(item?: PivotItem, ev?: React.MouseEvent<HTMLElement>) => { this.preload(item); }}>
          <PivotItem itemKey={"Pivot_DL_1"} headerText={`Opgaver til godkendelse (${this._allItems.filter(d => d.status === Status.WaitingForApproval).length})`}>
            <div >
              <ShimmeredDetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status === Status.WaitingForApproval)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                enableShimmer={this.state.isAssignmentsLoading}
                setKey="set"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_DL_2"} headerText={`Opgaver som mangler afklaring (${this._allItems.filter(d => d.status == Status.RequiresAdditionalInfo).length})`}>
            <div >
              <DetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status == Status.RequiresAdditionalInfo)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setRequiresAdditionalInfo"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_DL_3"} headerText={`Afviste opgaver (${this._allItems.filter(d => d.status == Status.Rejected).length})`}>
            <div >
              <DetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status == Status.Rejected)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setRejected"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_DL_4"} headerText={`Godkendte opgaver (${this._allItems.filter(d => d.status == Status.Approved).length})`}>
            <div >
              <MarqueeSelection selection={this._selection}>
                <DetailsList
                  className={styles.tasksList}
                  items={this.state.assignments.filter(d => d.status == Status.Approved)}
                  columns={this.state.assignment_Columns_DL}
                  selectionMode={SelectionMode.multiple}
                  selection={this._selection}
                  onRenderRow={this._onRenderRowDoubleClick?.bind(this)}
                  constrainMode={ConstrainMode.unconstrained}
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  setKey="setApproved"
                />
              </MarqueeSelection>
            </div>
          </PivotItem>
          {offlineCount > 0 && (
            <PivotItem itemKey={"Pivot_Offline"} headerText={`Offline opgaver (${offlineCount})`}>
              <div >
                <DetailsList
                  items={this.state.assignments.filter(d => d.status == Status.Offline)}
                  columns={this.state.assignment_Columns_DL}
                  selectionMode={SelectionMode.none}
                  onRenderRow={this._onRenderRow?.bind(this)}
                  constrainMode={ConstrainMode.unconstrained}
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  setKey="setOffline"
                />
              </div>
            </PivotItem>
          )}
          <PivotItem itemKey={"Pivot_Archive"} headerText={`Afsluttede opgaver ${archivedAssignmentsCount > 0 ? `(${archivedAssignmentsCount})` : ""}`}>
            <div >
              <DetailsList
                items={this.state.assignments.filter(d => d.status == Status.Completed)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setArchived"
              />
            </div>
          </PivotItem>
        </Pivot>
        {this.state.showAssignmentPanel && <AssignmentPanel allowSelectionOfSupplier={this.state.createOnbehalfOfSupplier} selectedAssignment={this.state.selectedAssignment} onChanged={(assignment: IAssignmentDTO, showAssignmentPanel: boolean) => { this.getData(showAssignmentPanel); this.setState({ selectedAssignment: assignment }); }} onDismiss={() => { this.setState({ showAssignmentPanel: false }); this.getData(false); }} />}
      </div>
    );
  }
  //#endregion Render Driftsleder

  //#region Render Indkøber
  private renderForPurchaser(): React.ReactElement<IDashboardProps> {
    const offlineCount = this._allItems.filter(d => d.status == Status.Offline).length;
    const CommandBar_Assignments: ICommandBarItemProps[] = [
      {
        key: 'newAssignment',
        text: 'Ny opgave på vegne af leverandør',
        iconProps: { iconName: 'Add' },
        disabled: this.state.isAssignmentsLoading,
        onClick: () => { this.setState({ selectedAssignment: undefined, createOnbehalfOfSupplier: true, showAssignmentPanel: true }) }
      }
    ];

    if (this.state.currentPivot == "Pivot_DL_4" && this.state.selectedAssignments != undefined && this.state.selectedAssignments?.length > 0) {
      CommandBar_Assignments.push({
        key: 'complete',
        text: `Afslut ${this.state.selectedAssignments?.length} opgave${this.state.selectedAssignments?.length > 1 ? "r" : ""}`,
        iconProps: { iconName: 'CheckMark' },
        disabled: this.state.selectedAssignments == undefined || this.state.selectedAssignments?.length == 0,
        onClick: () => { if (window.confirm("Er du sikker på, at du ønsker at markere de valgte opgaver som afsluttet?")) this.markAsComplete(); }
      });
    }

    const archivedAssignmentsCount = this._allItems.filter(d => d.status == Status.Completed).length;

    return (
      <div className={styles.dashboard}>
        <div className={styles.heading}><h3>Opgaveoverblik</h3></div>
        {this.state.isOffline && (
          <MessageBar messageBarType={MessageBarType.severeWarning}>
            Du er offline. Kun lokale opgaver vises, og nogle funktioner er deaktiveret.
          </MessageBar>
        )}
        <CommandBar className={styles.assignmentsCommandBar} items={CommandBar_Assignments} styles={{ root: { paddingLeft: "0px" } }} farItems={this.CreateFarMenuItems()} />
        <Pivot selectedKey={this.state.currentPivot} onLinkClick={(item?: PivotItem, ev?: React.MouseEvent<HTMLElement>) => { this.preload(item); }}>
          <PivotItem itemKey={"Pivot_DL_1"} headerText={`Opgaver til godkendelse (${this._allItems.filter(d => d.status === Status.WaitingForApproval).length})`}>
            <div >
              <ShimmeredDetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status === Status.WaitingForApproval)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                enableShimmer={this.state.isAssignmentsLoading}
                setKey="set"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_DL_2"} headerText={`Opgaver som mangler afklaring (${this._allItems.filter(d => d.status == Status.RequiresAdditionalInfo).length})`}>
            <div >
              <DetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status == Status.RequiresAdditionalInfo)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setRequiresAdditionalInfo"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_DL_3"} headerText={`Afviste opgaver (${this._allItems.filter(d => d.status == Status.Rejected).length})`}>
            <div >
              <DetailsList
                className={styles.tasksList}
                items={this.state.assignments.filter(d => d.status == Status.Rejected)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setRejected"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_DL_4"} headerText={`Godkendte opgaver (${this._allItems.filter(d => d.status == Status.Approved).length})`}>
            <div >
              <MarqueeSelection selection={this._selection}>
                <DetailsList
                  className={styles.tasksList}
                  items={this.state.assignments.filter(d => d.status == Status.Approved)}
                  columns={this.state.assignment_Columns_DL}
                  selectionMode={SelectionMode.multiple}
                  selection={this._selection}
                  onRenderRow={this._onRenderRowDoubleClick?.bind(this)}
                  constrainMode={ConstrainMode.unconstrained}
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  setKey="setApproved"
                />
              </MarqueeSelection>
            </div>
          </PivotItem>
          {offlineCount > 0 && (
            <PivotItem itemKey={"Pivot_Offline"} headerText={`Offline opgaver (${offlineCount})`}>
              <div >
                <DetailsList
                  items={this.state.assignments.filter(d => d.status == Status.Offline)}
                  columns={this.state.assignment_Columns_DL}
                  selectionMode={SelectionMode.none}
                  onRenderRow={this._onRenderRow?.bind(this)}
                  constrainMode={ConstrainMode.unconstrained}
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={true}
                  setKey="setOffline"
                />
              </div>
            </PivotItem>
          )}
          <PivotItem itemKey={"Pivot_Archive"} headerText={`Afsluttede opgaver ${archivedAssignmentsCount > 0 ? `(${archivedAssignmentsCount})` : ""}`}>
            <div >
              <DetailsList
                items={this.state.assignments.filter(d => d.status == Status.Completed)}
                columns={this.state.assignment_Columns_DL}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setArchived"
              />
            </div>
          </PivotItem>
        </Pivot>
        {this.state.showAssignmentPanel && <AssignmentPanel allowSelectionOfSupplier={this.state.createOnbehalfOfSupplier} selectedAssignment={this.state.selectedAssignment} onChanged={(assignment: IAssignmentDTO, showAssignmentPanel: boolean) => { this.getData(showAssignmentPanel); this.setState({ selectedAssignment: assignment }); }} onDismiss={() => { this.setState({ showAssignmentPanel: false }); this.getData(false); }} />}
      </div>
    );
  }
  //#endregion Render Indkøber

  //#region Render Admin
  private renderForAdmin(): React.ReactElement<IDashboardProps> {
    const CommandBar_Assignments: ICommandBarItemProps[] = [
      {
        key: 'openAssignment',
        text: 'Åbn',
        iconProps: { iconName: 'OpenPaneMirrored' },
        onClick: () => { this.setState({ createOnbehalfOfSupplier: false, showAssignmentPanel: true }) },
        disabled: !this.state.selectedAssignment
      }
    ];

    const archivedAssignmentsCount = this._allItems.filter(d => d.status == Status.Completed).length;

    return (
      <div className={styles.dashboard}>
        <div className={styles.heading}><h3>Alle opgaver</h3></div>
        <CommandBar className={styles.assignmentsContainer} items={CommandBar_Assignments} styles={{ root: { paddingLeft: "0px" } }} farItems={this.CreateFarMenuItems()} />
        <Pivot selectedKey={this.state.currentPivot} onLinkClick={(item?: PivotItem, ev?: React.MouseEvent<HTMLElement>) => { this.preload(item); }}>
          <PivotItem headerText={`Opgaver til godkendelse (${this._allItems.filter(d => d.status === Status.WaitingForApproval).length})`}>
            <div >
              <ShimmeredDetailsList
                items={this.state.assignments.filter(d => d.status === Status.WaitingForApproval)}
                columns={this.state.assignment_Columns_Admin}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                enableShimmer={this.state.isAssignmentsLoading}
                setKey="set"
              />
            </div>
          </PivotItem>
          <PivotItem headerText={`Godkendte opgaver (${this._allItems.filter(d => d.status == Status.Approved).length})`}>
            <div >
              <DetailsList
                items={this.state.assignments.filter(d => d.status == Status.Approved)}
                columns={this.state.assignment_Columns_Admin}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setApproved"
              />
            </div>
          </PivotItem>
          <PivotItem itemKey={"Pivot_Archive"} headerText={`Afsluttede opgaver ${archivedAssignmentsCount > 0 ? `(${archivedAssignmentsCount})` : ""}`}>
            <div >
              <DetailsList
                items={this.state.assignments.filter(d => d.status == Status.Completed)}
                columns={this.state.assignment_Columns_Admin}
                selectionMode={SelectionMode.none}
                onRenderRow={this._onRenderRow?.bind(this)}
                constrainMode={ConstrainMode.unconstrained}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                setKey="setArchived"
              />
            </div>
          </PivotItem>
        </Pivot>
        {this.state.showAssignmentPanel && <AssignmentPanel allowSelectionOfSupplier={this.state.createOnbehalfOfSupplier} selectedAssignment={this.state.selectedAssignment} onChanged={(assignment: IAssignmentDTO, showAssignmentPanel: boolean) => { this.getData(showAssignmentPanel); this.setState({ selectedAssignment: assignment }); }} onDismiss={() => { this.setState({ showAssignmentPanel: false }); this.getData(false); }} />}
      </div>
    );
  }
  //#endregion Render Admin

  //#region List render metoder
  private async preload(item?: PivotItem) {
    let pivotKey = item?.props.itemKey;
    let assignments = this._allItems;

    // Override sorting and default sort by approvedDate, desc on "Godkendt opgaver"-tab
    if (pivotKey == "Pivot_DL_4") {
      const columnKey = "approvedDate";
      const newColumns = this.GetUpdatedColumns(columnKey);
      this.setState({
        assignment_Columns_DL: newColumns,
      }, () => {
        assignments = Utilities.CopyAndSort(this.state.assignments.filter(d => d.status == Status.Approved), columnKey, true);
      });
    } else if (pivotKey == "Pivot_Archive") {
      if (this.state.assignments.filter(d => d.status == Status.Completed).length == 0) {
        const archivedAssignments = await this.assignmentService.GetAssignmentsFromArchive();
        this._allItems.push(...archivedAssignments);

        this.setState({
          assignments: this._allItems
        });
      }
    }

    this.setState({ currentPivot: pivotKey, assignments: assignments });
  }

  private CreateFarMenuItems() {
    return [
      {
        key: "search",
        onRender: () => <SearchBox
          placeholder="Søg efter opgave ..."
          className={styles.searchBox}
          onSearch={(newValue) => { this.onSearch(newValue); }}
          onChange={(event?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => { this.onSearch(newValue); }}
          onClear={ev => { this.onSearch(""); }}
        />
      }
    ];
  }

  private onSearch(searchTerm: string | undefined): void {
    this.setState({ searchTerm: searchTerm, assignments: searchTerm && searchTerm != "" ? this.filter(searchTerm) : this._allItems });
  }

  private filter(searchTerm: string): IAssignmentDTO[] {
    if (searchTerm.length == 9 && searchTerm.indexOf(".") > -1) {
      searchTerm = searchTerm.replaceAll(".", "");
    }

    return this._allItems.filter(i =>
      (i.status + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1 ||
      (i.supplierName + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1 ||
      (i.orderName + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1 ||
      (i.regionName + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1 ||
      (i.biomassCategory + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1 ||
      (i.hdaoNo + "").toLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1
    );
  }

  private async getData(preservePanelOpen: boolean) {
    this.setState(
      {
        isAssignmentsLoading: true,
        showAssignmentPanel: preservePanelOpen
      }
    );

    if (this.state.isOffline) {
      // Only show offline assignments when there's no connection
      const offlineAssignments = this.getOfflineAssignments();
      this._allItems = [...offlineAssignments];
      this.setState({
        assignments: offlineAssignments,
        isAssignmentsLoading: false,
      });
      return;
    }

    const onlineAssignments = await this.assignmentService.GetAssignments();
    const offlineAssignments = this.getOfflineAssignments();

    this._allItems = [...offlineAssignments, ...onlineAssignments];
    let assignments = this._allItems;

    assignments = this.TryUpdateDetailsListSortingFromLocalStorage();

    if (this.state.searchTerm && this.state.searchTerm != "") {
      assignments = this.filter(this.state.searchTerm);
    }

    let selectedIndex = assignments.findIndex(d => d.id == this.state.selectedAssignment?.id)

    this.setState({
      assignments: [...onlineAssignments, ...offlineAssignments],
      isAssignmentsLoading: false,
    });
  }

  private TryUpdateDetailsListSortingFromLocalStorage(): IAssignmentDTO[] {
    const currColumn = JSON.parse(localStorage.getItem(`Flisportal_RecentSortColumn`) + "") as IColumn;
    if (currColumn) {
      const newColumns = this.GetUpdatedColumns(currColumn.key);
      const assignments = Utilities.CopyAndSort(this._allItems, currColumn.fieldName!, currColumn.isSortedDescending);

      if (App.IsUserInRole("DL")) {
        this.setState({
          assignment_Columns_DL: newColumns,
        });
      } else {
        this.setState({
          assignment_Columns: newColumns,
        });
      }

      return assignments;
    }

    return this._allItems
  }

  private _onColumnClick(ev: React.MouseEvent<HTMLElement>, column: IColumn) {
    const newColumns = this.GetUpdatedColumns(column.key);
    const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

    localStorage.setItem(`Flisportal_RecentSortColumn`, JSON.stringify(currColumn));
    this._allItems = Utilities.CopyAndSort(this.state.assignments, currColumn.fieldName!, currColumn.isSortedDescending);

    this.setState({
      assignment_Columns: newColumns,
      assignments: this._allItems
    });
  }

  private _onColumnClickDL(ev: React.MouseEvent<HTMLElement>, column: IColumn) {
    const newColumns = this.GetUpdatedColumns(column.key);
    const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

    localStorage.setItem(`Flisportal_RecentSortColumn`, JSON.stringify(currColumn));
    this._allItems = Utilities.CopyAndSort(this.state.assignments, currColumn.fieldName!, currColumn.isSortedDescending);

    this.setState({
      assignment_Columns_DL: newColumns,
      assignments: this._allItems
    });
  }

  private GetUpdatedColumns(columnKey: string): IColumn[] {
    const newColumns: IColumn[] = this.getColumnsForCurrentPivot().slice();
    const currColumn: IColumn = newColumns.filter(currCol => columnKey === currCol.key)[0];

    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });

    return newColumns;
  }

  private getColumnsForCurrentPivot(): IColumn[] {
    let columns = this.state.assignment_Columns;

    if (App.IsUserInRole("DL")) {
      columns = this.state.assignment_Columns_DL;
    } else if (App.IsUserInRole("Admin")) {
      columns = this.state.assignment_Columns_Admin;
    }

    return columns;
  }

  private _onRenderRow: IDetailsListProps['onRenderRow'] = props => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      return <div title="Klik for at åbne opgave" onClick={() => { this.setState({ selectedAssignment: props.item, showAssignmentPanel: true }); }}><DetailsRow {...props} styles={customStyles} /></div>
    }
    return null;
  }

  private _onRenderRowDoubleClick: IDetailsListProps['onRenderRow'] = props => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      return <div title="Dobbeltklik for at åbne opgave" onDoubleClick={() => { this.setState({ selectedAssignment: props.item, showAssignmentPanel: true }); }}><DetailsRow {...props} styles={customStyles} /></div>
    }
    return null;
  }
  //#endregion List render metoder
}